<template>
  <div class="Layout">
    <div class="Layout__top">
      <the-header></the-header>
    </div>
    <div class="Layout__left">
      <the-menu></the-menu>
    </div>
    <div class="Layout__right">
      <the-breadcrumb></the-breadcrumb>
      <div class="Layout__main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import TheHeader from './Header/Header.vue';
import TheMenu from './Menu.vue';
import TheBreadcrumb from './Breadcrumb.vue';

export default {
  name: 'Layout',
  components: {
    TheHeader,
    TheMenu,
    TheBreadcrumb,
  },
};
</script>

<style lang="scss">
  .Layout {
    display: flex;
    flex-wrap: wrap;
    width:  100%;
    * {
      font-size: 11px!important;
    }
    &__top {
      flex: 1 0 100%;
      margin: 1em 0;
    }

    &__left {
      flex: 0 1 150px;
      margin-right: 3em;
    }

    &__right {
      width: calc(100% - 150px - 3em);
      max-width: 850px;
    }
  }
</style>
